import React from "react";
import { string, node, bool } from "prop-types";
import cx from "classnames";
import Image from "../Image";

function Card({
    isDesktop,
    icon,
    iconClass,
    iconWithText,
    title,
    content,
    bottom,
    rightContent,
    rightArrow,
    rightContextMenu,
    className,
    checks,
    hrClass,
    rightMenu,
    flowFlex,
    mobileBottom,
    stackContentBelow,
}) {
    const titleNode =
        stackContentBelow && title == null ? null : <div className="card__component-item-title">{title}</div>;
    const bodyInMainRow = !stackContentBelow;
    return (
        <div className={cx("card__component-item", className)}>
            <div className={isDesktop ? "d-flex" : "align-items-start"}>
                {checks}
                {icon ? <Image className={iconClass} src={icon} /> : undefined}
                {iconWithText}
                <div className="w-100">
                    {titleNode}
                    {bodyInMainRow && (
                        <>
                            <div className="card__component-item-text">{content}</div>
                            {bottom && <div className="card__component-item-bottom">{bottom}</div>}
                        </>
                    )}
                </div>
                {rightMenu}
            </div>
            {stackContentBelow && (
                <>
                    <div className="card__component-item-text card__component-item-text--stack-below">{content}</div>
                    {bottom && <div className="card__component-item-bottom">{bottom}</div>}
                </>
            )}
            {!isDesktop && mobileBottom && <div className="card__component-item-mobile-bottom">{mobileBottom}</div>}
            {!isDesktop && <hr className={hrClass} />}
            {rightContent && (
                <div
                    className={cx("d-flex align-items-center justify-content-end", {
                        "w-100": !isDesktop && !flowFlex,
                    })}>
                    {rightContent}
                    {rightArrow && <Image className="card-arrow-icon" src="images/arrow-right.svg" />}
                    {rightContextMenu}
                </div>
            )}
        </div>
    );
}

Card.propTypes = {
    icon: string,
    iconClass: string,
    iconWithText: node,
    title: node,
    content: node,
    bottom: node,
    rightContent: node,
    rightArrow: bool,
    className: string,
    isDesktop: bool.isRequired,
    checks: node,
    hrClass: string,
    rightMenu: node,
    rightContextMenu: node,
    flowFlex: bool,
    mobileBottom: node,
    stackContentBelow: bool,
};

Card.defaultProps = {
    icon: "",
    iconClass: "",
    iconWithText: null,
    title: null,
    content: null,
    bottom: null,
    rightContent: null,
    rightArrow: false,
    className: "",
    checks: null,
    hrClass: "",
    rightMenu: null,
    rightContextMenu: null,
    flowFlex: false,
    mobileBottom: null,
    stackContentBelow: false,
};

export default Card;
